import { Flex } from 'antd';
import styles from '../navbar.module.scss';
import { CrossFillIcon } from '../../../common/all-icons/custom-icons';

const MiddleSection = () => {
  const points = ['No Insurance Required', 'No Monthly Fees', 'No Waiting'];

  return (
    <div className={styles.benfitsSection}>
      <div className={styles.middleWrap}>
        <div className={styles.pointsWrap} style={{ maxWidth: '650px' }}>
          <div className={styles.secondaryText}>
            This isn't another wellness app or quick fix. It's comprehensive medical care designed around your life,
            your schedule, and your goals.
          </div>
          <div style={{ flexDirection: 'column' }} className={styles.pointWrap}>
            {points.map((point) => {
              return (
                <Flex gap={16}>
                  <CrossFillIcon />
                  <div className={styles.crossPoint}>{point}</div>
                </Flex>
              );
            })}
          </div>
        </div>
        <Flex vertical className={styles.quoteBox}>
          <div className={styles.thirdText}>
            "I finally found a healthcare approach that treats me like a person, not a number. The results speak for
            themselves."
          </div>
          <div style={{ color: 'var(--ant-color-primary)' }} className={styles.forthText}>
            — Sarah M.
          </div>
        </Flex>
      </div>
    </div>
  );
};

export default MiddleSection;
